export default __webpack_public_path__ + "static/media/KH.3d6b1be6.svg";